import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { NavBar as VanNavBar, Icon as VanIcon } from 'vant'
import { useStatsStore } from '@/stores/stats-store'
import LotterySwitcher from '@/components/lottery-switcher'

export const StatsHeader = defineComponent({
  name: 'StatsHeader',
  props: {
    title: { type: String, default: '资讯统计' },
    showPeriod: { type: Boolean, default: true },
  },
  setup(props) {
    const router = useRouter()
    const statsStore = useStatsStore()

    return () => (
      <VanNavBar
        fixed
        title={props.title}
        onClickLeft={() => router.push('/')}
      >
        {{
          left: () => <VanIcon name="arrow-left" color="#333" size="16" />,
          right: () => (
            <div class="flex items-center gap-1.5">
              {props.showPeriod && (
                <div>
                  <span>期数</span>
                  <input
                    class="period"
                    type="number"
                    min="1"
                    max="999"
                    value={statsStore.periodCount}
                    onInput={(e: Event) => {
                      const v = Number((e.target as HTMLInputElement).value)
                      if (Number.isFinite(v) && v > 0) statsStore.setPeriodCount(v)
                    }}
                    onBlur={() => {
                      if (statsStore.periodCount == null || statsStore.periodCount < 1) {
                        statsStore.setPeriodCount(100)
                      }
                    }}
                  />
                </div>
              )}
              <LotterySwitcher />
            </div>
          ),
        }}
      </VanNavBar>
    )
  },
})

export default StatsHeader
